<template>
  <Stack class="stk-p-10">
    <Title>Content</Title>

    <Title size="5">Badge</Title>

    <Badges>
      <Badge>Default</Badge>
      <Badge status="success">Success</Badge>
      <Badge status="info">Info</Badge>
      <Badge status="warning">Warning</Badge>
      <Badge status="danger">Danger</Badge>
    </Badges>

    <Hr />

    <Title size="5">Callout</Title>

    <Stack gap="2">
      <Callout>Default</Callout>
      <Callout status="success" iconBefore="fas fa-check">This is a Success message Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</Callout>
      <Callout status="info" iconBefore="fas fa-info">This is a Info message Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</Callout>
      <Callout status="warning" iconBefore="fas fa-exclamation-triangle">This is a Warning message Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</Callout>
      <Callout status="danger" iconBefore="fas fa-ban">This is a Danger message Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</Callout>
    </Stack>

    <Hr />

    <Title size="5">Title and Subtitle</Title>

    <div>
      <Title>Title</Title>
      <Subtitle>Subtitle</Subtitle>
    </div>

    <Hr />

    <Title>Form</Title>

    <Title size="5">Button</Title>

    <Buttons>
      <Button>Default Button</Button>
      <Button variant="primary">Primary Button</Button>
      <Button variant="ghost">Ghost Button</Button>
    </Buttons>

    <Buttons>
      <Button iconAfter="fas fa-sync">Sync Tasks</Button>
      <Button iconBefore="fas fa-download" variant="primary">Download Video</Button>
      <Button iconOnly="fas fa-trash" />
    </Buttons>

    <Buttons size="3">
      <Button>Default Button</Button>
      <Button variant="primary">Primary Button</Button>
      <Button variant="ghost">Ghost Button</Button>
    </Buttons>

    <Hr />

    <Title size="5">Form Fields</Title>

    <Field>
      <Label>Email Address</Label>
      <input class="stk-input" type="text" placeholder="e.g. alex@example.com" />
    </Field>

    <Field>
      <Label>Full Name</Label>

      <div class="tw-flex tw-gap-2">
        <div class="stk-select">
          <select>
            <option>Mr</option>
            <option>Mrs</option>
            <option>Ms</option>
          </select>

          <Icon />
        </div>

        <input class="stk-input tw-grow" type="text" value="Alexander" />

        <input class="stk-input tw-grow" type="text" value="Lincoln" />

        <input class="stk-input tw-grow" type="text" value="Mahone" />
      </div>
    </Field>

    <Hr />

    <Title>Graphic</Title>

    <Title size="5">Icons</Title>

    <div>
      <Icon icon="fas fa-info" />
      <IconButton icon="fas fa-download" />
    </div>

    <Hr />

    <Title size="5">Loaders</Title>

    <Loader />

    <LoaderWithText>Fetching Entity…</LoaderWithText>

    <Hr />

    <Title>Layout</Title>

    <Title size="5">Level</Title>

    <Level>
      <LevelLeft>On the left</LevelLeft>
      <LevelRight>On the right</LevelRight>
    </Level>

    <Hr />

    <Title size="5">Stack</Title>

    <Stack>
      <p>Default Gap</p>
      <p>First line</p>
      <p>Second line</p>
      <p>Third line</p>
    </Stack>

    <Stack gap="0">
      <p>No gap</p>
      <p>First line</p>
      <p>Second line</p>
      <p>Third line</p>
    </Stack>

    <Hr />

    <Title>Navigation</Title>

    <Title size="5">Menu</Title>

    <Menu>
      <MenuLabel>Sections</MenuLabel>
      <MenuList>
        <MenuItem active>
          Personal Details
        </MenuItem>
        <MenuItem>
          Investment Accounts
        </MenuItem>
        <MenuItem>
          Assets and Liabilities
        </MenuItem>
        <MenuItem>
          Cash Flow
        </MenuItem>
        <MenuItem>
          Insurance
          <Icon icon="fas fa-exclamation-triangle" />
        </MenuItem>
        <MenuItem>
          Estate
        </MenuItem>
        <MenuItem>
          Tax
        </MenuItem>
        <MenuItem>
          Key Relationships
        </MenuItem>
      </MenuList>
    </Menu>

    <Hr />

    <Title size="5">Toggle</Title>

    <Stack gap="2">
      <Field>
        <Label>Basic Toggle</Label>
        <Toggle v-model="basicToggle" @change="onToggleChange" />
        <p class="tw-text-sm tw-text-gray-600">Current value: {{ basicToggle }}</p>
      </Field>

      <Field>
        <Label>Toggle with Loading State</Label>
        <Toggle v-model="loadingToggle" :loading="isLoading" @change="onLoadingToggleChange" />
        <p class="tw-text-sm tw-text-gray-600">Loading: {{ isLoading }}</p>
      </Field>

      <Field>
        <Label>Pre-enabled Toggle</Label>
        <Toggle v-model="enabledToggle" />
        <p class="tw-text-sm tw-text-gray-600">Current value: {{ enabledToggle }}</p>
      </Field>
    </Stack>

    <Title size="5">Pills</Title>

    <Pills>
      <PillsList>
        <PillItem
          icon="fas fa-book"
          active="true"
        >
          Dossier
        </PillItem>

        <PillItem
          icon="fas fa-folder-open"
        >
          Documents
        </PillItem>

        <PillItem
          icon="fas fa-align-left"
        >
          Note-taking
        </PillItem>

        <PillItem
          icon="fas fa-lock"
        >
          Permissions and Groups
        </PillItem>
      </PillsList>
    </Pills>
  </Stack>
</template>

<script setup>
import { ref } from 'vue'
import {
  Badge,
  Badges,
  Callout,
  Subtitle,
  Title,
  Button,
  Buttons,
  Field,
  TextInput,
  Toggle,
  Label,
  Hr,
  Icon,
  IconButton,
  Loader,
  LoaderWithText,
  MeetingAssistantLogo,
  Level,
  LevelLeft,
  LevelRight,
  Stack,
  PillItem,
  Pills,
  PillsList,
  MenuItem,
  Menu,
  MenuLabel,
  MenuList,
} from '@stakeui'

// Toggle state
const basicToggle = ref(false)
const loadingToggle = ref(false)
const enabledToggle = ref(true)
const isLoading = ref(false)

// Toggle handlers
const onToggleChange = (value) => {
  console.log('Basic toggle changed to:', value)
}

const onLoadingToggleChange = (value) => {
  console.log('Loading toggle changed to:', value)
  // Simulate loading state
  isLoading.value = true
  setTimeout(() => {
    isLoading.value = false
  }, 1500)
}
</script>